import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CommissionRateForm from "./CommissionRateForm";
import { Spin } from "antd";
import { createCommissionRate } from "../../../store/commission/commissionActions";

const CreateCommissionRate = ({ parentRefreshHandler }) => {
  const dispatch = useDispatch();

  const initialValues = {
    ProducerCode1Key: 0,
    ProducerCode2Key: 0,
    RatePercent: 0,
  };

  const onSubmitHandler = (values) => dispatch(createCommissionRate(values));

  const loading = useSelector((state) => state.commission.selectedLoading);

  return (
    <Spin spinning={loading} delay={500}>
      <CommissionRateForm
        onSubmitHandler={onSubmitHandler}
        initialValues={initialValues}
        handleParentRefresh={parentRefreshHandler}
        isNew={true}
      />
    </Spin>
  );
};

export default CreateCommissionRate;
